(function () {
  const LA_TIMEZONE = 'America/Los_Angeles';

  function getMillisecondsUntilEndOfDayInLA(now) {
    now = now || new Date();
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: LA_TIMEZONE,
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(now);

    let hour = 0;
    let minute = 0;
    let second = 0;

    for (const part of parts) {
      if (part.type === 'hour') hour = Number(part.value === '24' ? '0' : part.value);
      if (part.type === 'minute') minute = Number(part.value);
      if (part.type === 'second') second = Number(part.value);
    }

    const secondsRemaining = (23 - hour) * 3600 + (59 - minute) * 60 + (59 - second);
    return Math.max(0, secondsRemaining * 1000);
  }

  function formatDealCountdown(milliseconds) {
    const totalSeconds = Math.max(0, Math.floor(milliseconds / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return (
      String(hours).padStart(2, '0') +
      ':' +
      String(minutes).padStart(2, '0') +
      ':' +
      String(seconds).padStart(2, '0')
    );
  }

  function tick() {
    const display = formatDealCountdown(getMillisecondsUntilEndOfDayInLA());
    document.querySelectorAll('[data-mp-deal-countdown]').forEach(function (el) {
      el.textContent = display;
    });
  }

  tick();
  window.setInterval(tick, 1000);
})();
